import { render } from "./ReportsTable.vue?vue&type=template&id=e48ae654&scoped=true"
import script from "./ReportsTable.vue?vue&type=script&lang=js"
export * from "./ReportsTable.vue?vue&type=script&lang=js"

import "./reports-table.scss?vue&type=style&index=0&id=e48ae654&lang=scss&scoped=true"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48ae654"]])

export default __exports__